// src/App.js
import React, { useEffect, useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import UserRoutes from './routes/UserRoutes';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

// AppContext
import { AppProvider, AppContext } from './components/User/AppContext';

export default function App() {
  // Initialize AOS once on mount
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <BrowserRouter>
      <Toaster position="top-center" />
      <AppProvider>
        <UserApp />
      </AppProvider>
    </BrowserRouter>
  );
}

function UserApp() {
  const { loading, error } = useContext(AppContext);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-red-600">
        Error loading app data.
      </div>
    );
  }

  return <UserRoutes />;
}
